<template name="exam">
  <div class="page-exam">
    <Top :isDetailPage="false" :trainingId="routeId" @changeVisitListStatus="inviteListShow = true"></Top>

    <main class="main-container container" v-show="!isExamResShow">
      <div class="lesson-name">
        {{ examName }}
        <i class="iconfont icon-close" @click="handleCloseExam"></i>
      </div>
      <div class="question-item" v-for="(question, idx) in questions" :key="idx" :id="question.questionId">
        <div class="question-title">
          {{ idx + 1 }}.{{ question.questionTitle }}
        </div>
        <div class="question-content">
          <radioSelect
            :isH5System="true"
            v-if="question.questionType === 0 || question.questionType === 2"
            :dataList="question.questionOptions"
            propName="optionName"
            :idScopeName="`question-${idx}`"
            :isDisabled="!isSubmitShow"
            v-model="question.userAnswer"
          >
          </radioSelect>
          <examCheckboxSelect
            v-if="question.questionType === 1"
            :dataList="question.questionOptions"
            propName="optionName"
            :idScopeName="`question-${idx}`"
            :isDisabled="!isSubmitShow"
            :correctAnswer="!isSubmitShow ? question.correctAnswer : []"
            v-model="question.userAnswer"
          >
          </examCheckboxSelect>
          <textarea
            v-if="question.questionType === 3 || question.questionType === 4"
            :placeholder="$t('inputComment')"
            :rows="question.questionType === 3 ? 3 : 5"
            :disabled="!isSubmitShow"
            v-model.trim="question.userAnswer">
          </textarea>
        </div>
        <errorMsg :isError="question.isError"></errorMsg>
      </div>
      <div class="submit-area" v-show="isSubmitShow">
        <div class="submit-btn" @click="handleSubmit">
          {{$t('submit')}}
        </div>
      </div>
    </main>
    <div class="exam-result" v-show="isExamResShow">
      <div class="res-img">
        <img v-if="isPassed" src="../../assets/images/external/exam-passed.png" >
        <img v-else src="../../assets/images/external/exam-failed.png" >
      </div>
      <div class="res-desc">
        <h3>{{  isPassed ? this.$t('passExam') : this.$t('failedExam')  }}</h3>
        <p>{{$t('thankYouParticipating')}}</p>
      </div>
      <div class="res-operation" @click="handleExamRes">
        {{ isPassed ? this.$t('Return') : this.$t('Retest') }}
      </div>
    </div>
    <footerMenuExternal :trainingId="routeId" :isContactSelectShow="false" :isDetailPage="false" @changeVisitListStatus="inviteListShow = true"></footerMenuExternal>
    <footerExternal :isLoginPage="false"></footerExternal>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
    <alertModal :isModalShown="isSubmitModalShow" :modalTitle="$t('confirSubmission')" @cancel="cancelSubmit" @confirm="submitData"></alertModal>
  </div>
</template>
<!-- TODO: Check if Top, footerMenuExternal, footerExternal components are working fine -->
<script type="text/javascript">
import Top from '@/views/external/top.vue';
import footerExternal from '@/components/footerExternal.vue';
import footerMenuExternal from '@/components/footerMenuExternal.vue';
import radioSelect from '@/components/radioSelect.vue';
import examCheckboxSelect from '@/components/examCheckboxSelect.vue';
import errorMsg from '@/components/errorMsg.vue';
import alertModal from '@/components/alertModal.vue';
import { checkNested, scrollErrMsgToView } from '@/utils/utils';
import { getExamDetail, submitExam } from '@/utils/api';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'Exam',
  data() {
    return {
      inviteListShow: false,
      isLoading: false,
      routeId: 0,
      lessonId: 0,
      examId: 0,
      examName: '',
      questions: [],
      isSubmitShow: false,
      isSubmitModalShow: false,
      isExamResShow: false,
      isPassed: false,
    };
  },
  components: {
    Top,
    footerExternal,
    footerMenuExternal,
    examCheckboxSelect,
    radioSelect,
    errorMsg,
    alertModal,
    Loading,
  },
  created() {
    const { id, lessonId, examId } = this.$route.params;
    this.routeId = id;
    this.lessonId = lessonId;
    this.examId = examId;
    this.isLoading = true;
    getExamDetail(this.routeId, this.lessonId, this.examId).then((res) => {
      this.isLoading = false;
      if (checkNested(res, 'data', 'content', 'model')) {
        const { examName, isAnswer, questions } = res.data.content.model;
        this.isSubmitShow = !isAnswer;
        this.examName = examName;
        this.questions = questions.map(q => ({ ...q }));
        this.questions.forEach((q) => {
          const correctAnswer = JSON.parse(q.correctAnswer);
          q.correctAnswer = correctAnswer;
          if (q.questionType === 0 || q.questionType === 1 || q.questionType === 2) {
            const optionsArr = JSON.parse(q.questionOptions);
            q.userAnswer = q.userAnswer ? JSON.parse(q.userAnswer) : q.questionType === 1 ? [] : '';
            q.questionOptions = optionsArr.map((option, idx) => ({
              optionName: option,
              id: idx, // use idx as id is ok, because we add idScopeName in component
              checked: isAnswer && correctAnswer.includes(idx),
            }));
          } else {
            q.userAnswer = q.userAnswer;
          }
          q.isError = false;
        });
      }
    });
  },
  methods: {
    handleCloseExam() {
      this.$router.go(-1);
    },
    checkQuestions() {
      let flag = true;
      const questions = this.questions.map(q => ({ ...q }));
      questions.forEach((q) => {
        if (q.userAnswer === '' || !q.userAnswer.length) {
          q.isError = true;
          flag = false;
        } else {
          q.isError = false;
        }
      });
      this.questions = questions;
      return flag;
    },
    handleSubmit() {
      // #1 check if all question is finished before move further
      const flag = this.checkQuestions();
      if (flag) {
        this.isSubmitModalShow = true;
        window.scrollTo(0, 0);
      } else {
        scrollErrMsgToView();
      }
    },
    cancelSubmit() {
      this.isSubmitModalShow = false;
    },
    submitData() {
      const model = {};
      model.ticketId = this.routeId;
      model.lessonId = this.lessonId;
      model.examId = this.examId;
      model.questions = this.questions.map((q) => ({
        questionId: q.questionId,
        answer: (q.questionType === 0 || q.questionType === 2) ? JSON.stringify([parseInt(q.userAnswer, 10)]) :
                q.questionType === 1 ? JSON.stringify(q.userAnswer.map((a => parseInt(a, 10)))) : q.userAnswer
      }));
      // console.log(JSON.stringify(model));
      this.isSubmitModalShow = false;
      this.isLoading = true;
      submitExam(model).then((res) => {
        this.isLoading = false;
        if (checkNested(res, 'data', 'content', 'model')) {
          this.isPassed = res.data.content.model.pass;
          this.isExamResShow = true;
        }
      });
    },
    handleExamRes() {
      if (this.isPassed) {
        // go back to traning list page
        this.$router.go(-2);
      } else {
        window.location.reload();
      }
    },
  },
};
</script>
<style lang="scss">
  .page-exam {
    .detail-header {
      box-shadow: 0 0 15px rgba(100, 100, 100, 0.15);
    }
  }
</style>
<style scoped lang="scss">
@import '../../scss/variables.scss';
  .btn {
    cursor: pointer;
    color: #fff;
    font-size: 15px;
    width: 100%;
    line-height: 46px;
    text-align: center;
    object-fit: contain;
    border-radius: 5px;
    background-image: linear-gradient(81deg, #f36443, #e42029);
  }
  .main-container {
    padding: 20px 30px 60px;
    .lesson-name {
      font-size: 14px;
      font-weight: bold;
      color: #4a4a4a;
      position: relative;
      padding-right: 1em;
      .icon-close {
        cursor: pointer;
        position: absolute;
        right: 0;
        top: 0;
      }
    }
    .question-item {
      padding: 20px;
      margin-top: 15px;
      box-shadow: 0 2px 13px 2px rgba(230, 230, 230, 0.5);
      .question-title {
        font-size: 15px;
        color: #4a4a4a;
        font-weight: bold;
      }
      .question-content {
        margin-top: 20px;
        textarea {
          border: none;
          font-size: 13px;
          width: 100%;
          background: #f0f0f0;
          padding: 10px 1em;
          color: #4a4a4a;
        }
      }
    }
    .submit-area {
      margin-top: 46px;
      padding-bottom: 56px;
      @include respond-to('md') {
        display: flex;
        flex-direction: row-reverse;
      }
      .submit-btn {
        @extend .btn;
        @include respond-to('md') {
          max-width: 320px;
        }
      }
    }
  }
  .exam-result {
    display: flex;
    position: absolute;
    top: 58px;
    bottom: 58px;
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .res-img {
      width: 27%;
      text-align: center;
      max-width: 150px;
      img {
        max-width: 100%;
      }
    }
    .res-desc {
      margin-top: 15px;
      color: #4a4a4a;
      text-align: center;
      h3 {
        font-size: 20px;
        font-weight: bold;
      }
      p {
        font-size: 14px;
      }
    }
    .res-operation {
      @extend .btn;
      width: 242px;
      margin-top: 50px;
    }
  }
</style>
